// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../../assets/upcoming.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../../assets/complete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../../assets/close_red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../../assets/session/activity.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../../assets/session/light_mode.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../../assets/session/star.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../../assets/session/chat_bubble.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullSessionItem{
    display: flex;
    flex-direction: column;
    padding: 12px 21px;
    background-color: #fff;
    border-radius: 30px;
    /*box-shadow: 0px 0px 15px #0003;*/
    box-shadow: 0px 0px 15px #00000009;
    position: relative;
    --buttonMinWidth: 86px;
    --buttonMaxWidth: 140px;
}

.fullSessionItem_edit_button{
    width: 24px;
    height: 24px;
    border-radius: 100%;
    /*background-color: #0009;*/
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 14px;
    background-position: center;
    background-repeat: no-repeat;
}

.fullSessionItem_loader_overlay{
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 24px;
    background-color: #fff9;
    display: flex;
    align-items: center;
    padding-left: 19px;
    top: 0;
    left: 0;

    .commonSpinner{
        font-size: 0;
    }
}

/* Responsive font sizing for ultra-narrow screens */
@media (max-width: 360px) {
    .fullSessionItem_time {
        font-size: calc(13px * var(--fontScaler));
    }
}

.fullSessionItem_head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
}

.fullSessionItem_date{
    font-style: normal;
    font-weight: 700;
    font-size: calc(14px * var(--fontScaler));
    line-height: 14px;
    color: #000000;
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fullSessionItem_time{
    font-style: italic;
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 24px;
    text-align: center;
    color: #979797;
    white-space: nowrap;
    flex: 0 0 auto;
    min-width: 72px;
    /*width: 100%;*/
    padding: 0px 10px;
}

.fullSessionItem_attachment{
    background: #FFFFFF;
    border: 1px solid #14AE5C;
    border-radius: 24px;
    padding: 2px 8px;
    display: flex;
    gap: 8px;
    align-items: center;

    width: var(--sessionButtonWidth);
    flex-shrink: 0;
    justify-content: space-between;
}

.fullSessionItem_attachment_wait{
    width: var(--sessionButtonWidth);
    border-radius: 24px;
    padding: 2px 8px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
}

.fullSessionItem_attachment svg{
    fill: #14AE5C;
}

.fullSessionItem_attachment_text{
    width: var(--sessionButtonWidth);
    text-align: center;
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 14px;

    color: #14AE5C;
}

.fullSessionItem_attachment_icon{
    margin-bottom: 2px;
}

.fullSessionItem_attachment_upload{
    background-color: #14AE5C;
}

.fullSessionItem_attachment_upload .fullSessionItem_attachment_text{
    color: #fff;
}

.fullSessionItem_attachment_upload svg{
    fill: #fff;
}

.fullSessionItem_status{
    display: flex;
    align-items: center;
    gap: 4px;
    border-left: 1px solid #0002;
    border-right: 1px solid #0002;
    padding-right: 6px;
    width: 140px;
    flex-shrink: 0;
    justify-content: center;
    margin-right: 3px;
}

.fullSessionItem_status_icon{
    font-size: 0;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    /*background-color: #0009;*/
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 15px;
    background-position: center;
    background-repeat: no-repeat;
}

.fullSessionItem_status_text{
    font-style: normal;
    font-weight: 700;
    font-size: calc(14px * var(--fontScaler));
    line-height: 24px;
    color: #FFA825; /*#14AE5C*/
}

.fullSessionItem_status--finished .fullSessionItem_status_text{
    color: #14AE5C;
}

.fullSessionItem_status--finished .fullSessionItem_status_icon{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.fullSessionItem_status--cancelled .fullSessionItem_status_text{
    color: #E23424;
}

.fullSessionItem_status--cancelled .fullSessionItem_status_icon{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 24px;
}

.fullSessionItem_drop{
    display: grid;
    grid-template-rows: 0fr;
    transition-duration: 200ms;
    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
    overflow: hidden;

    border: none;
    width: 100%;

    font-weight: 400;
    font-size: calc(10px * var(--fontScaler));
    line-height: 150%;
    color: #B8BCCA;
}


.fullSessionItem_drop_content{
    height: 100%;
    overflow: hidden;
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 16px;
    color: #000000;
}

.fullSessionItem--opened .fullSessionItem_drop{
    grid-template-rows: 1fr;
    padding-top: 28px;
}

.fullSessionItem_drop_menu{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    padding: 20px 0px;
}

.fullSessionItem_drop_button{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px 11px;
    gap: 7px;
    height: 22px;

    background: #E2E9FC;
    border-radius: 25px;

    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 16px;
    color: #000000;
}

.fullSessionItem_drop_button::before{
    content: '';
    width: 16px;
    height: 16px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.fullSessionItem_drop_button--analyze::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}


.fullSessionItem_drop_button--watch::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}


.fullSessionItem_drop_button--add::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}


.fullSessionItem_drop_button--chat::before{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.fullSessionItem_drop_button--active{
    background-color: #14AE5C99;
}
.fullSessionItem_progress_percent{
    position: absolute;
    width: calc(100% - 4px);
    height: calc(29px - 4px);
    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 14px;

    color: #000;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sessions/fullSessionItem/FullSessionItem.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,kCAAkC;IAClC,kCAAkC;IAClC,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;;IAEd,yDAAuD;IACvD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;;IAEP;QACI,YAAY;IAChB;AACJ;;AAEA,oDAAoD;AACpD;IACI;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,mBAAmB;;IAEnB,gCAAgC;IAChC,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;;IAEd,yDAA2D;IAC3D,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc,EAAE,UAAU;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yDAA2D;AAC/D;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yDAA4D;IAC5D,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,0BAA0B;IAC1B,+DAA+D;IAC/D,gBAAgB;;IAEhB,YAAY;IACZ,WAAW;;IAEX,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,YAAY;;IAEZ,mBAAmB;IACnB,mBAAmB;;IAEnB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yDAAmE;IACnE,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,yDAAmE;AACvE;;;AAGA;IACI,yDAAqE;AACzE;;;AAGA;IACI,yDAA+D;AACnE;;;AAGA;IACI,yDAAsE;AAC1E;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,WAAW;AACf","sourcesContent":[".fullSessionItem{\n    display: flex;\n    flex-direction: column;\n    padding: 12px 21px;\n    background-color: #fff;\n    border-radius: 30px;\n    /*box-shadow: 0px 0px 15px #0003;*/\n    box-shadow: 0px 0px 15px #00000009;\n    position: relative;\n    --buttonMinWidth: 86px;\n    --buttonMaxWidth: 140px;\n}\n\n.fullSessionItem_edit_button{\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    /*background-color: #0009;*/\n    flex-shrink: 0;\n\n    background-image: url('../../../../../assets/edit.svg');\n    background-size: 14px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.fullSessionItem_loader_overlay{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 24px;\n    background-color: #fff9;\n    display: flex;\n    align-items: center;\n    padding-left: 19px;\n    top: 0;\n    left: 0;\n\n    .commonSpinner{\n        font-size: 0;\n    }\n}\n\n/* Responsive font sizing for ultra-narrow screens */\n@media (max-width: 360px) {\n    .fullSessionItem_time {\n        font-size: calc(13px * var(--fontScaler));\n    }\n}\n\n.fullSessionItem_head{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n}\n\n.fullSessionItem_date{\n    font-style: normal;\n    font-weight: 700;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 14px;\n    color: #000000;\n    flex: 1 1 auto;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.fullSessionItem_time{\n    font-style: italic;\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 24px;\n    text-align: center;\n    color: #979797;\n    white-space: nowrap;\n    flex: 0 0 auto;\n    min-width: 72px;\n    /*width: 100%;*/\n    padding: 0px 10px;\n}\n\n.fullSessionItem_attachment{\n    background: #FFFFFF;\n    border: 1px solid #14AE5C;\n    border-radius: 24px;\n    padding: 2px 8px;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n\n    width: var(--sessionButtonWidth);\n    flex-shrink: 0;\n    justify-content: space-between;\n}\n\n.fullSessionItem_attachment_wait{\n    width: var(--sessionButtonWidth);\n    border-radius: 24px;\n    padding: 2px 8px;\n    flex-shrink: 0;\n    display: flex;\n    justify-content: center;\n}\n\n.fullSessionItem_attachment svg{\n    fill: #14AE5C;\n}\n\n.fullSessionItem_attachment_text{\n    width: var(--sessionButtonWidth);\n    text-align: center;\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 14px;\n\n    color: #14AE5C;\n}\n\n.fullSessionItem_attachment_icon{\n    margin-bottom: 2px;\n}\n\n.fullSessionItem_attachment_upload{\n    background-color: #14AE5C;\n}\n\n.fullSessionItem_attachment_upload .fullSessionItem_attachment_text{\n    color: #fff;\n}\n\n.fullSessionItem_attachment_upload svg{\n    fill: #fff;\n}\n\n.fullSessionItem_status{\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    border-left: 1px solid #0002;\n    border-right: 1px solid #0002;\n    padding-right: 6px;\n    width: 140px;\n    flex-shrink: 0;\n    justify-content: center;\n    margin-right: 3px;\n}\n\n.fullSessionItem_status_icon{\n    font-size: 0;\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    /*background-color: #0009;*/\n    flex-shrink: 0;\n\n    background-image: url('../../../../../assets/upcoming.svg');\n    background-size: 15px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.fullSessionItem_status_text{\n    font-style: normal;\n    font-weight: 700;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 24px;\n    color: #FFA825; /*#14AE5C*/\n}\n\n.fullSessionItem_status--finished .fullSessionItem_status_text{\n    color: #14AE5C;\n}\n\n.fullSessionItem_status--finished .fullSessionItem_status_icon{\n    background-image: url('../../../../../assets/complete.svg');\n}\n\n.fullSessionItem_status--cancelled .fullSessionItem_status_text{\n    color: #E23424;\n}\n\n.fullSessionItem_status--cancelled .fullSessionItem_status_icon{\n    background-image: url('../../../../../assets/close_red.svg');\n    background-size: 24px;\n}\n\n.fullSessionItem_drop{\n    display: grid;\n    grid-template-rows: 0fr;\n    transition-duration: 200ms;\n    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n    overflow: hidden;\n\n    border: none;\n    width: 100%;\n\n    font-weight: 400;\n    font-size: calc(10px * var(--fontScaler));\n    line-height: 150%;\n    color: #B8BCCA;\n}\n\n\n.fullSessionItem_drop_content{\n    height: 100%;\n    overflow: hidden;\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 16px;\n    color: #000000;\n}\n\n.fullSessionItem--opened .fullSessionItem_drop{\n    grid-template-rows: 1fr;\n    padding-top: 28px;\n}\n\n.fullSessionItem_drop_menu{\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 20px;\n    padding: 20px 0px;\n}\n\n.fullSessionItem_drop_button{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 3px 11px;\n    gap: 7px;\n    height: 22px;\n\n    background: #E2E9FC;\n    border-radius: 25px;\n\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 16px;\n    color: #000000;\n}\n\n.fullSessionItem_drop_button::before{\n    content: '';\n    width: 16px;\n    height: 16px;\n    background-image: url('../../../../../assets/session/activity.svg');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n}\n\n.fullSessionItem_drop_button--analyze::before{\n    background-image: url('../../../../../assets/session/activity.svg');\n}\n\n\n.fullSessionItem_drop_button--watch::before{\n    background-image: url('../../../../../assets/session/light_mode.svg');\n}\n\n\n.fullSessionItem_drop_button--add::before{\n    background-image: url('../../../../../assets/session/star.svg');\n}\n\n\n.fullSessionItem_drop_button--chat::before{\n    background-image: url('../../../../../assets/session/chat_bubble.svg');\n}\n\n.fullSessionItem_drop_button--active{\n    background-color: #14AE5C99;\n}\n.fullSessionItem_progress_percent{\n    position: absolute;\n    width: calc(100% - 4px);\n    height: calc(29px - 4px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 14px;\n\n    color: #000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
